import { useCurrentPermissionsStore } from '@onereach/permissions-ui';
import { defineStore } from 'pinia';
import { computed } from 'vue';

export const usePermissionsStore = defineStore('permissions', () => {
  const store = useCurrentPermissionsStore();

  return {
    currentUserPermissions: computed(() => store.currentUserPermissions),
    isPermissionsLoading: computed(() => store.isPermissionsLoading),
    noAccess: computed(() => store.noAccess),
    getCurrentPermissions: store.getCurrentPermissions,
    hasPermission: store.hasPermission,
    resetStore: store.resetStore,
  };
});
